<template>
  <div>
    <span v-for="option in options" :key="option" class="option" :class="[{ active: border === option }, `option--${option}`]" @click.stop.prevent="update(option)"></span>
  </div>
</template>

<script>
  export default {
    props: ['border'],
    
    data() {
      return {
        options: ['default', 'fade-top-black']
      }
    },

    methods: {
      update(option) {
        this.$emit('update:border', option);
      }
    }
  }
</script>

<style scoped>
  .option.active:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 1px solid #000;
  }

  .option {
    position: relative;
    display: inline-block;

    height: 1em;
    width: 1em;
    margin: 2px;
    border: 1px solid #fff;

    margin-right: 0.35em;
  }

  .option--default {
    background: #fff;
  }

  .option--default:after {
    content: '';
    position: absolute;

    border-top: 2px solid red;
    width: calc(100% + 6px);

    transform: rotate(45deg);
    transform-origin: 0% 0%;
  }

  .option--fade-top-black:after {
    content: '';

    position: absolute;
    top: 0;
    bottom: calc(80% - 1px);
    left: 1px;
    right: 1px;
    background: #000;
  }
</style>